import './App.css';
import MyCalendar from './Calendar';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="calendar-container">
          <MyCalendar />
        </div>
      </header>
    </div>
  );
  
}

export default App;
